import React from "react";
import Header from "./Header";
import Footer from "./Footer"
import Seo from "./Seo";

const sections = [
    { id: "introduction", label: "Introduction" },
    { id: "information-collected", label: "Information collected" },
    { id: "purpose-of-processing", label: "Purpose of processing" },
    { id: "privacy-roles", label: "Privacy roles" },
    { id: "aadhaar-information", label: "Aadhaar information" },
    { id: "sharing-of-information", label: "Sharing of information" },
    { id: "retention-and-deletion", label: "Retention and deletion" },
    { id: "user-rights", label: "User rights" },
    { id: "privacy-contact", label: "Privacy contact" },
];

function PrivacyPolicy() {

    return (
        <div className="terms-of-services">
            <Seo
                title="SignuluOne Privacy Policy | Personal Data Practices"
                description="Learn how SignuluOne collects, uses, shares, retains and protects personal data for website visitors, customers, administrators, recipients and signers."
                canonical="https://www.signuluone.com/privacy-policy.html"
            />
            <Header />
            <main className="container container-lg container-xl container-xxl pricing_box">
                <h4>Privacy Policy</h4>
                <div className="row toc-page-row">
                    <aside className="col-lg-3 toc-sidebar">
                        <div className="toc-sidebar-sticky">
                            <p className="toc-sidebar-title">On this page</p>
                            <ul>
                                {sections.map((s) => (
                                    <li key={s.id}><a href={`#${s.id}`}>{s.label}</a></li>
                                ))}
                            </ul>
                        </div>
                    </aside>

                    <div className="col-lg-9 toc-page-content">
                        <section id="introduction">
                            <h4>1. Introduction</h4>
                            <p>MITI Sphere Solutions Private Limited, through Signulu, respects the privacy of website visitors, customers, administrators, users, recipients and signers.</p>
                            <p>This Privacy Policy explains how Signulu collects, uses, shares, retains and protects personal data.</p>
                        </section>

                        <section id="information-collected">
                            <h4>2. Information collected</h4>
                            <p>Signulu may process:</p>
                            <ul>
                                <li>names, email addresses and mobile numbers;</li>
                                <li>organisation and designation details;</li>
                                <li>account and administrator information;</li>
                                <li>documents, templates and form-field information;</li>
                                <li>signer and recipient information;</li>
                                <li>IP address, device, browser and timestamp information;</li>
                                <li>authentication and signing status;</li>
                                <li>consent records and audit trails;</li>
                                <li>digital-certificate and document-hash information;</li>
                                <li>billing, support and communication information; and</li>
                                <li>information voluntarily provided by users.</li>
                            </ul>
                        </section>

                        <section id="purpose-of-processing">
                            <h4>3. Purpose of processing</h4>
                            <p>Personal data may be processed to:</p>
                            <ul>
                                <li>create and manage accounts;</li>
                                <li>provide signing and document workflows;</li>
                                <li>authenticate signers;</li>
                                <li>send transaction notifications;</li>
                                <li>generate audit records;</li>
                                <li>maintain security and prevent fraud;</li>
                                <li>provide support;</li>
                                <li>process payments and invoices;</li>
                                <li>comply with applicable law; and</li>
                                <li>enforce contractual rights.</li>
                            </ul>
                        </section>

                        <section id="privacy-roles">
                            <h4>4. Privacy roles</h4>
                            <p>Signulu acts as a Data Fiduciary when it determines the purpose and manner of processing, such as for website enquiries, account registration, billing, support and security.</p>
                            <p>Where an enterprise Customer uploads documents and recipient information, that Customer ordinarily acts as the Data Fiduciary and Signulu processes the information on the Customer's instructions.</p>
                        </section>

                        <section id="aadhaar-information">
                            <h4>5. Aadhaar information</h4>
                            <p>Where Aadhaar-based eSign is used, authentication is performed through the relevant authorised eSign service.</p>
                            <p>Unless expressly disclosed and legally permitted, Signulu does not store Aadhaar OTPs, biometric information, private signing keys or complete Aadhaar authentication credentials.</p>
                            <p>Signulu may retain limited transaction details such as authentication status, response code, certificate information, timestamp and document hash.</p>
                        </section>

                        <section id="sharing-of-information">
                            <h4>6. Sharing of information</h4>
                            <p>Information may be shared with authorised cloud-hosting providers, Certifying Authorities, eSign Service Providers, communication gateways, payment providers, customer-support providers and Government authorities where necessary to provide the service or comply with law.</p>
                            <p>Service providers are permitted to process information only for authorised purposes and subject to appropriate contractual safeguards.</p>
                        </section>

                        <section id="retention-and-deletion">
                            <h4>7. Retention and deletion</h4>
                            <p>Personal data and documents will be retained for the period required to provide the service, comply with the Customer's instructions, maintain transaction evidence, meet legal obligations and resolve disputes.</p>
                            <p>Deleted information may remain temporarily in backups or immutable security records until the applicable retention cycle is completed.</p>
                        </section>

                        <section id="user-rights">
                            <h4>8. User rights</h4>
                            <p>Subject to applicable law, individuals may request access, correction, completion, updating or erasure of their personal data, withdraw consent, submit a grievance and exercise other rights available under applicable data-protection law.</p>
                            <p>Requests relating to documents controlled by an enterprise Customer may be referred to that Customer.</p>
                        </section>

                        <section id="privacy-contact">
                            <h4>9. Privacy contact</h4>
                            <p>For privacy enquiries or requests, contact:</p>
                            <p>
                                Privacy / Grievance Officer: Legal Team<br />
                                Email: <a href="mailto:privacy@signulu.com">privacy@signulu.com</a><br />
                                Address: MILLENNIUM Tower, 5th Floor, Plot# 10/1, Sector – III, HUDA Techno Enclave, Madhapur, Hyderabad, Telangana – 500081.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}
export default PrivacyPolicy;
